// rollbar.js
import Rollbar from 'rollbar';

export default {
    install(app, options) {
        const rollbar = new Rollbar(options);
        rollbar.configure({
            /**
             * An optional function that will be used to ignore uncaught exceptions based on its return value.
             * The function signature should be: function checkIgnore(isUncaught, args, payload) { ... } and should return
             * true if the error should be ignored.
             *
             * @param isUncaught Boolean - true if error caught in client, false if not
             * @param args Array - contains error message as array items
             * @param payload Object - The javascript object that is about to be sent to Rollbar. This will contain all
             * of the context and payload information for this notifier and error. This parameter is useful
             * for advanced ignore functionality
             *
             * @return Boolean - true if error should be ignored, otherwise false
             **/
            // eslint-disable-next-line no-unused-vars
            checkIgnore: function (isUncaught, args, payload) {
                const toIgnores = ['status code 401', 'status code 402', 'Network error'];
                return args && typeof args[0] === 'string' && toIgnores.some((toIgnore) => args[0].includes(toIgnore));
            },
        });
        app.config.errorHandler = (error) => {
            if (error && error.message && error.message.includes('rollbar')) {
                console.warn('Avoiding recursive Rollbar logging:', error.message);
                return;
            }
            rollbar.error(error);
            console.error(error);
        };
        app.provide('rollbar', rollbar);
    },
};
